var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { dia } from '@joint/plus';
var Task = /** @class */ (function (_super) {
    __extends(Task, _super);
    function Task() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.markup = [{
                tagName: 'rect',
                selector: 'body'
            }, {
                tagName: 'rect',
                selector: 'header'
            }, {
                tagName: 'text',
                selector: 'headerText'
            }, {
                tagName: 'text',
                selector: 'bodyText'
            }];
        return _this;
    }
    Task.prototype.defaults = function () {
        return __assign(__assign({}, _super.prototype.defaults), { type: 'kanban.Task', attrs: {
                body: {
                    fill: '#FFF',
                    height: 'calc(h)',
                    width: 'calc(w)',
                    strokeWidth: 1,
                    rx: 4,
                    ry: 4,
                    stroke: '#DDDDDD',
                },
                header: {
                    fill: 'transparent',
                    stroke: 'none',
                    height: 40,
                    width: 'calc(w)'
                },
                headerText: {
                    cursor: 'text',
                    x: 20,
                    y: 20,
                    fontWeight: 'Bold',
                    fontFamily: 'Helvetica',
                    textVerticalAnchor: 'top',
                    textAnchor: 'start',
                    fontSize: 17,
                    fill: '#333',
                    textWrap: {
                        maxLineCount: 1,
                        ellipsis: true,
                        width: -40
                    }
                },
                bodyText: {
                    cursor: 'text',
                    x: 20,
                    y: 55,
                    textVerticalAnchor: 'top',
                    textAnchor: 'start',
                    fontWeight: 'Normal',
                    fontFamily: 'Helvetica',
                    lineHeight: '1.5em',
                    textWrap: {
                        width: -40,
                        ellipsis: true,
                        height: -55
                    },
                    fontSize: 16,
                    fill: '#666',
                }
            }, z: 2 });
    };
    Task.isTask = function (cell) {
        return cell.get('type') === 'kanban.Task';
    };
    return Task;
}(dia.Element));
export { Task };
